import i18n from '@/i18n/i18n'
import client_lookup from '@/assets/json/clientLookups.json'
import { DateTime } from 'luxon'

const dateFormat = (value) => {
  return DateTime.fromISO(value).toFormat('dd/MM/yyyy')
}
export default function () {
  return {
    handleRefundMethod: (value, item) => {
      const { refundMethodTypes } = client_lookup
      const refundMethod = {
        [refundMethodTypes.none]: i18n.global.t('bankWallet'),
        [refundMethodTypes.iban]: i18n.global.t('bank'),
        [refundMethodTypes.cheque]: i18n.global.t('cheque'),
        [refundMethodTypes.creditCard]: i18n.global.t('creditCard'),
        [refundMethodTypes.bankWallet]: i18n.global.t('AmwalWallet')
      }

      return refundMethod[value]
    },
    isMainRequest: (value, item) => {
      return !!value ? i18n.global.t('Yes') : i18n.global.t('No')
    },
    dateFormat
  }
}
